<script>
import { useAuthUtils } from '@/pages/auth/auth-utils'
import { maSessionStorage } from '@/lib/storage'
import { maLogger } from '@/base/logger'

import MaTestimonials from './components/MaTestimonials.vue'
import MaSaAuthLogos from './components/MaSaAuthLogos.vue'
import MaRegisterForm from './components/MaRegisterForm.vue'

export default {
  name: 'MaRegisterPage',
  components: {
    MaSaAuthLogos,
    MaRegisterForm,
    MaTestimonials,
  },
  setup() {
    const { checkLoggedInAndRedirect } = useAuthUtils()

    return {
      checkLoggedInAndRedirect,
    }
  },
  data() {
    return {
      email: null,
    }
  },
  mounted() {
    this.checkLoggedInAndRedirect()
    this.setInitialReferrer()
  },
  methods: {
    setInitialReferrer() {
      const { utm_source, ref } = this.$route.query
      const referrer = utm_source || ref
      if (referrer) {
        maLogger.info(`Initial Referrer: ${referrer}`)
        maSessionStorage.initialReferrer = referrer
      }
    },
  },
}
</script>

<template>
  <div class="ma-auth-register">
    <MaSaAuthLogos />
    <MaRegisterForm />
    <MaTestimonials />
  </div>
</template>

<style lang="scss" scoped>
.ma-auth-register {
  @apply min-h-full w-full md:px-0 lg:w-auto bg-white flex flex-col mx-auto md:flex-row justify-between items-stretch;
}
</style>
